// COPIED FROM GLOBAL WEBSITE
// Please keep changes syncronised between projects
// todo - find a better way to share react / typescript / javascript utils between projects


// Converts "Dallas - Fort Worth" - "dallas-fort-worth"
const formatUrlKey = (input: string): string =>
    input
        ?.trim()                          // Remove leading and trailing whitespace
        ?.replace(/\s+/g, '-')            // Replace one or more spaces/tabs/etc. with a single hyphen
        ?.replace(/[^a-zA-Z0-9-]/g, '')   // Remove all non-alphanumeric characters except hyphens
        ?.replace(/-+/g, '-')             // Collapse multiple consecutive hyphens into one
        ?.replace(/^-|-$/g, '')           // Remove leading or trailing hyphens
        ?.toLowerCase() ?? undefined;                  // Convert entire string to lowercase



export default formatUrlKey;